import { defineStore } from 'pinia'
import { ref } from 'vue';

export const usePageStore = defineStore('pagenation', {
  state: () => ({
    totalPage: ref<number>(10),
    currPage: ref<number>(1),
    pageGroupSize: ref<number>(0)
  }),
  actions: {
    setTotalPage(page: number) {
      this.totalPage = page;
    },
    setCurrPage(page: number) {
      this.currPage = page;
    },
    initPage() {
      this.currPage = 1;
    },
    setPageGroupSize(size: number) {
      this.pageGroupSize = size;
    }
  },
  getters: {
    getTotalPage(state): any {
      return state.totalPage;
    },
    getCurrPage(state): any {
      return state.currPage;
    },
    getPageGroupSize(state): any {
      return state.pageGroupSize;
    }
  },
});